import { useState } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LinesEllipsis from 'react-lines-ellipsis';

import classes from './MyPortfolioCard.module.css';

const MyPortfolioCard = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const openMenuHandler = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenuHandler = () => {
    setAnchorEl(false);
  };

  const transformDate = dateString => {
    if (dateString == null) {
      return '-';
    }
    const originalDate = dateString;

    const date = new Date(originalDate);
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    };
    const formatDate = date.toLocaleDateString('es-ES', options);
    return formatDate;
  };

  const showDegreeHandler = (url, course, date) => () => {
    props.showDegree(url, course, date);
    setAnchorEl(false);
  };

  return (
    <div className={classes.cardContainer}>
      <IconButton
        className={classes.moreBtn}
        onClick={openMenuHandler}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        classes={{ paper: classes.menuContainer }}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenuHandler}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {props.itemData.hasDiploma ? (
          <MenuItem
            className={classes.menuItem}
            onClick={showDegreeHandler(
              props.itemData.urlCloudFront,
              props.itemData.nombre,
              props.itemData.endDate
            )}
          >
            Ver diploma
          </MenuItem>
        ) : (
          <MenuItem className={classes.menuItem}>
            Sin diploma
          </MenuItem>
        )}
        <MenuItem
          className={classes.menuItem}
          component="a"
          href={`https://mayahii.com/${props.itemData.academyShortName}`}
          target="_blank"
        >
          Ir al curso
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          component="a"
          href={`https://mayahii.com/${props.itemData.academyShortName}/c/${props.itemData.idCourse}`}
          target="_blank"
        >
          Ir a la academia
        </MenuItem>
      </Menu>
      <figure className={classes.courseImage}>
        <img
          src={props.itemData.courseImage}
          className={classes.img}
        />
      </figure>
      <aside className={classes.complementaryInfoContainer}>
        <p className={classes.courseAcademy}>
          {props.itemData.academyName}
        </p>
        <p className={classes.courseTitle}>
          <LinesEllipsis
            text={props.itemData.nombre}
            maxLine="3"
            ellipsis="..."
            trimRight
            basedOn="letters"
          />
        </p>
        <p className={classes.courseEndData}>
          {transformDate(props.itemData.endDate)}
        </p>
      </aside>
    </div>
  );
};

MyPortfolioCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  itemData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  showDegree: PropTypes.object
};

export default MyPortfolioCard;
